import React from 'react'

import { SWATCHES } from '../picture-studio-engine'

interface ColorPickerProps {
  value: string
  onChange: (color: string) => void
}

export function ColorPicker({ value, onChange }: ColorPickerProps) {
  return (
    <div>
      <span className="mb-1 block text-xs text-light-4">Color</span>
      <div className="flex items-center gap-2">
        <input
          type="color"
          value={value}
          onChange={(e) => onChange(e.target.value)}
          className="h-[34px] w-10 cursor-pointer rounded-md border border-neutral-1 bg-white p-0.5"
        />
        <span className="text-xs text-light-4">{value}</span>
      </div>
      <div className="mt-2 flex flex-wrap gap-1.5">
        {SWATCHES.map((color) => (
          <button
            key={color}
            type="button"
            aria-label={color}
            onClick={() => onChange(color)}
            className={`h-[26px] w-[26px] rounded-md border-2 hover:border-light-2 ${
              value.toLowerCase() === color.toLowerCase()
                ? 'border-rest-p1'
                : 'border-transparent'
            }`}
            style={{ backgroundColor: color }}
          />
        ))}
      </div>
    </div>
  )
}
